/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFuncFolders = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m17.6 15-1-2H12v9h10v-7h-4.4zm2.4 5h-6v-5h1.4l1 2H20v3zM12 4H7.6l-1-2H2v9h10V4zm-2 5H4V4h1.4l1 2H10v3zm-5 5H3v6h6v-2H5z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgFuncFolders as FuncFolders };
